import { render, staticRenderFns } from "./MoveGoods.vue?vue&type=template&id=2423c65a"
import script from "./MoveGoods.vue?vue&type=script&lang=js"
export * from "./MoveGoods.vue?vue&type=script&lang=js"
import style0 from "./MoveGoods.vue?vue&type=style&index=0&id=2423c65a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports